import tippy from './node_modules/tippy.js'
export default tippy
